/** Mises en forme partagées — transposition des helpers de la console HTML. */

/**
 * ⚠️ ÉCART ASSUMÉ avec l'original — le seul de ce fichier.
 *
 * La console HTML déclare `const NBSP=' '` : le nom annonce une espace
 * insécable, mais la valeur est une espace ORDINAIRE (U+0020), vérifiée
 * caractère par caractère dans la source. Le nom dit l'intention, le code fait
 * l'inverse — « 12 500 F » peut donc se couper en fin de ligne, « 12 » d'un
 * côté et « 500 F » de l'autre.
 *
 * On pose ici l'espace fine insécable (U+202F) que le nom promettait. C'est un
 * écart VOLONTAIRE : toute comparaison automatique des deux surfaces le verra
 * et doit le compter comme attendu.
 */
const FINE = ' '

/** `fmtF()` : 12500 → « 12 500 F », arrondi, séparateurs insécables. */
export function fcfa(n: number | null | undefined): string {
  const v = Math.round(n ?? 0)
  return `${v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, FINE)}${FINE}F`
}

/** `fmtDate()` : ISO → « 25/09/2026 ». Chaîne vide si la date manque. */
export function dateCourte(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`
}

/** Heure « 14:05 » — utilisée par les cartes de course et la messagerie. */
export function heure(iso: string | null | undefined): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

/** `isToday()` — compare les jours civils locaux, pas un écart de 24 h. */
export function estAujourdHui(iso: string | null | undefined): boolean {
  if (!iso) return false
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return false
  return d.toDateString() === new Date().toDateString()
}

/** Jours de la semaine, index ISO : `JOURS[1]` = « Lundi ». */
export const JOURS = ['', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'] as const

/** Les quartiers de Bamako proposés à la prise d'appel. */
export const QUARTIERS = [
  'Hamdallaye ACI 2000',
  'Badalabougou',
  'Hippodrome',
  'Kalaban Coura',
  'Djicoroni Para',
  'Magnambougou',
  'Sogoniko',
  'Lafiabougou',
  'Quartier du Fleuve',
  'Niaréla',
] as const

/** `normPhone()` — ne garde que les chiffres, pour comparer deux numéros. */
export function chiffresTelephone(p: string | null | undefined): string {
  return (p ?? '').replace(/[^\d]/g, '')
}
